<div
  class="min-h-screen"
  [ngStyle]="getBackgroundStyles()"
>
  <div
    class="flex h-screen flex-col overflow-hidden"
    [ngStyle]="getBackgroundStyles()"
    [style.backgroundColor]="backgroundColor | contentBuilderColor"
    [style.color]="textColor | contentBuilderColor"
  >
    @if (header) {
      <div
        id="header overflow-hidden"
        class="flex-shrink-0"
      >
        <app-block-list [blockIdList]="header"></app-block-list>
      </div>
    }

    <div
      id="body"
      class="flex flex-1 flex-row gap-2.5 overflow-hidden px-5 py-5"
    >
      @if (!hideLeftBody) {
        <div
          id="body_left"
          class="flex-shrink-0"
        >
          <app-block-list [blockIdList]="forceType(sidebar)"></app-block-list>
        </div>
      }
      <div
        id="body_right"
        class="h-full flex-1 overflow-y-auto px-5 scrollbar-hide"
      >
        <router-outlet></router-outlet>
      </div>
    </div>
    @if (footer) {
      <div class="footer">
        <app-block-list [blockIdList]="footer"></app-block-list>
      </div>
    }
  </div>
</div>

<ng-template #blockingPopupContent>
  <div class="flex h-screen w-screen flex-col items-center justify-center gap-8 bg-neutral-50">
    <div>
      <h2 class="w-fit-content text-center text-6xl font-bold">
        {{ 'KIOSK_SHOP_PAGE.BLOCKING_POPUP.TITLE' | translate }}
      </h2>
    </div>
    @let resetUIProcessing = resetUIProcessing$ | async;
    <app-button-atom
      size="XXL"
      thickSize="XXL"
      [label]="'KIOSK_SHOP_PAGE.BLOCKING_POPUP.RETURN' | translate"
      (click)="resetUI()"
      type="light"
      [iconUrl]="resetUIProcessing?.isLoading ? 'assets/images/spinner.svg' : ''"
    ></app-button-atom>
  </div>
</ng-template>
